import React from "react";
import Typical from 'react-typical';

import classes from "./Home.module.css";




const Home = () => {
  return (
    <div id="home" className={classes.home}>
      <div className={classes.cc}>
        <div className={classes.parent_box}>
          <h2 className={classes.Name_heading}>Nikhil Gupta</h2>
          <span className={classes.sub_heading}>
          <Typical
        steps={['I am a Software Developer',3000,'MERN/MEAN Stack | JavaScript | Bootstrap | HTML & CSS', 2000 ]}
         wrapper="span"
        
      />

          </span>
        </div>
      
      </div>
      
    </div>
  );
};

export default Home;
